// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { LIST_ASSETS } from "./action";

export function canListAssets(scope: Scope): boolean {
  return scope.iamActions.includes(LIST_ASSETS);
}
